import * as Config from '../../../../../../config';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import {
  removeHistoryTracks,
  addToast,
  setModal
 } from "../../../../../../actions/index";

import DragItem from '../../../../dnd/DragItem';
import Column from '../../Column';
import ColumnChecker from '../../ColumnChecker';
import ColumnActions from '../../ColumnActions';
import ColumnCover from '../../ColumnCover';
import ColumnTrack from '../../ColumnTrack';
import ColumnLabel from '../../ColumnLabel';
import ColumnGenre from '../../ColumnGenre';
import ColumnBpmKey from '../../ColumnBpmKey';
import ColumnMore from '../../ColumnMore';
import ColumnDate from '../../ColumnDate';
import ColumnTime from '../../ColumnTime';
import ColumnRemixer from '../../ColumnRemixer';
import ColumnRowActions from '../../ColumnRowActions';

import ModalCTA from '../../../../modal/ModalCTA';
import ModalButton from '../../../../modal/ModalButton';

import useTrackAccess from '../../hooks/useTrackAccess';

// React.memo(
const ConnectedRowHistory = ({
  item, index, width, height, className = 'item', style,
  idParent, onClick,
  end,
  onLoadMore, removeHistoryTracks, addToast, setModal,
  isTablet
}) => {

  const removeItem = (id) => () => {
    const deleteItem = () => {
      removeHistoryTracks(id);
      addToast({ content: <span>1 track(s) removed from Recently played.</span>, typeClass: 'neutral', iconStyle: { padding: 16, marginRight: 16 } });
    }
    setModal({ //V2
      content: (
        <ModalCTA
          title={`Remove track(s)`}
          description={`Are you sure you want to remove the selected track(s)?`}
          styleContainer={{marginTop: `-60%`, marginLeft: `-10%`}}
          styleBody={{gap: 32}}
          classModal={`bottom-reduce`}
        >
          <ModalButton label={`Remove`} className={`red-white`} onClick={deleteItem} keyPress={true} />
          <ModalButton label={`Cancel`} className={`cancel`}  />
        </ModalCTA>
      )
    })
  } 
  const {
    isDisabled,
    playerLoadSong,
    previewPlayer, isPreview, stylePreview,
    beginDnD, showContextMenu, ContextMenuContent,
    addToCart, isInCart,
    addToPlaylist
  } = useTrackAccess(item, idParent, index, removeItem(item.id), false);

  const onClickRow = (e) => onClick(item, e, index);

  const RSizeChecker = 10;
  const RSizeNumber = 5;
  const RSizeActions = isTablet ? 90: 50;
  const RSizeCover = 48;
  const RSizeMore = 30;
  const RSizeExtra = 45;
  const RSizeKey = 90;
  const RSizeRelease = 95;
  const RSizeTime = 50;

  const RTotal = RSizeChecker + RSizeNumber + RSizeActions + RSizeCover + RSizeMore + RSizeKey + RSizeRelease + RSizeTime + RSizeExtra;
  let RSizeTrack = ((width - RTotal) * 33 / 100);
  let RSizeRemixer = ((width - RTotal) * 20 / 100);
  let RSizeLabel = ((width - RTotal) * 25 / 100);
  let RSizeGenre = ((width - RTotal) * 22 / 100);
  RSizeTrack += (Config.LIST_HEADER_HAS_REMIXER) ? 0 : RSizeRemixer;

  return (
    <>
      <DragItem type={`TRACK`} idParent={idParent} begin={beginDnD} end={end} onClick={onClickRow} ContextMenuContent={ContextMenuContent} onMouseEnter={onLoadMore ? onLoadMore(index) : null} item={item} className={`${isPreview && `preview`} ${(previewPlayer && !previewPlayer.isPlaying) && 'off'} ${className} ${(isDisabled) && `disabled`} `} style={stylePreview({ width, height })}>
        <ColumnChecker width={RSizeChecker} isDisabled={isDisabled} trackID={item.id} value={null} />
        <Column className={`type-small`} style={{ width: RSizeNumber, textAlign: `center` }} value={``} />
        <ColumnActions width={RSizeActions} keyID={item.id} isPreview={(!previewPlayer.isPlaying || !isPreview)} isTablet={isTablet}
            onClickPlayDeckA={playerLoadSong(1)} onClickPlayDeckB={playerLoadSong(2)}
            onPreviewBackward={previewPlayer.backward} onPreviewForward={previewPlayer.forward} 
            enableActionsAutomix={false}
        />
        <ColumnCover width={RSizeCover} item={item} previewPlayer={previewPlayer} />
        <ColumnTrack width={RSizeTrack} item={item} includeRemixers={false} containerStyle={{ marginRight: 10 }}  />
        { (Config.LIST_HEADER_HAS_REMIXER) && (
          <ColumnRemixer width={RSizeRemixer} remixers={item.remixers ? item.remixers : []} />
        )}
        <ColumnLabel width={RSizeLabel - 8} item={item} style={{ marginRight: 8 }}  />
        <ColumnGenre width={RSizeGenre} item={item}  />
        <ColumnBpmKey width={RSizeKey} item={item} />
        <ColumnDate width={RSizeRelease} date={item.release} />
        <ColumnTime width={RSizeTime} duration={item.length} durationMs={item.length_ms} />
        <ColumnRowActions width={RSizeExtra} onClickCart={addToCart} isInCart={isInCart} onClickPlaylist={addToPlaylist} />
        <ColumnMore width={RSizeMore} id={item.id} onClick={showContextMenu} />
      </DragItem>
    </>
  )

};

ConnectedRowHistory.propTypes = {
  item: PropTypes.object.isRequired,
  idParent: PropTypes.any,
  index: PropTypes.number.isRequired,
  width: PropTypes.any.isRequired,
  height: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  end: PropTypes.func
}

const RowHistory = connect(
  state => ({
    isTablet: state.layoutTablet
  }),
  dispatch => ({
    removeHistoryTracks: (id) => dispatch(removeHistoryTracks(id)),
    addToast: (content) => dispatch(addToast(content)),
    setModal: (content) => dispatch(setModal(content)),
  })
)(ConnectedRowHistory);

export default RowHistory;
